/// <amd-module name="SuiteCommerce.Blog.PostCardsCCT.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostCardsCCT.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Post.Collection", "SuiteCommerce.Blog.Common"], function (require, exports, Backbone_1, Post_Collection_1, Common_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostCardsCCTModel = /** @class */ (function (_super) {
        __extends(PostCardsCCTModel, _super);
        function PostCardsCCTModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.filtersAvailable = [
                {
                    field: 'custrecord_blog_post_cct_card_auth_fltr',
                    taxonomy: Common_1.AvailableTaxonomies.author,
                },
                {
                    field: 'custrecord_blog_post_cct_card_terms_fltr',
                    separator: '',
                    taxonomy: Common_1.AvailableTaxonomies.term,
                },
                {
                    field: 'custrecord_blog_post_cct_card_cat_fltr',
                    taxonomy: Common_1.AvailableTaxonomies.category,
                },
                {
                    field: 'custrecord_blog_post_cct_card_tags_fltr',
                    separator: ',',
                    taxonomy: Common_1.AvailableTaxonomies.tag,
                },
            ];
            return _this;
        }
        Object.defineProperty(PostCardsCCTModel.prototype, "cctTitle", {
            get: function () {
                return this.get('custrecord_sc_blog_post_cct_card_heading') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostCardsCCTModel.prototype, "postQuantity", {
            get: function () {
                return this.get('custrecord_sc_blog_post_cct_card_cards') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostCardsCCTModel.prototype, "useVerticalLayout", {
            get: function () {
                return (this.get('custrecord_sc_blog_post_cct_card_align') &&
                    this.get('custrecord_sc_blog_post_cct_card_align') === 'T');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostCardsCCTModel.prototype, "posts", {
            get: function () {
                if (!this.get('posts')) {
                    this.posts = new Post_Collection_1.PostCollection();
                }
                return this.get('posts');
            },
            set: function (posts) {
                this.set('posts', posts);
            },
            enumerable: true,
            configurable: true
        });
        PostCardsCCTModel.prototype.getBlogPostSearcherOptions = function () {
            var requestOptions = {
                taxonomies: [],
                settings: {
                    pageNumber: 1,
                    pageSize: 5,
                },
            };
            if (this.searchText) {
                requestOptions.searchPhrase = Common_1.sanitizeString(this.searchText.trim());
            }
            else {
                requestOptions.taxonomies = this.filters;
            }
            return requestOptions;
        };
        Object.defineProperty(PostCardsCCTModel.prototype, "searchText", {
            get: function () {
                return this.get('custrecord_blog_post_cct_card_text_fltr') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostCardsCCTModel.prototype, "filters", {
            get: function () {
                var _this = this;
                var filters = [];
                this.filtersAvailable.forEach(function (filter) {
                    filters = filters.concat(_this.buildFilterParam(filter));
                });
                return filters;
            },
            enumerable: true,
            configurable: true
        });
        PostCardsCCTModel.prototype.buildFilterParam = function (filter) {
            var filterEntries = this.get(filter.field);
            if (filterEntries) {
                if (filter.separator) {
                    return filterEntries
                        .split(filter.separator)
                        .map(function (entryValue) {
                        return {
                            name: filter.taxonomy,
                            value: entryValue.trim(),
                        };
                    });
                }
                return [
                    {
                        name: filter.taxonomy,
                        value: "" + filterEntries,
                    },
                ];
            }
            return [];
        };
        return PostCardsCCTModel;
    }(Backbone_1.Model));
    exports.PostCardsCCTModel = PostCardsCCTModel;
});
